export const formVehicleNaming = {
  NEW_VEHICLE_FORM: 'new-vehicle-form',
  EDIT_VEHICLE_FORM: 'edit-vehicle-form',
};
